<template>
  <div>
    <div class="wushuju">
      <img v-if="theme == 2" src="../assets/nodata@2x1.png" alt="" />
      <img v-else src="../assets/wushuju.png" alt="" />
      <p :class="theme == 2 ? 'colorccc' : 'color999'">暂无数据</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    theme: Number,
  },
};
</script>

<style lang="less" scoped>
.wushuju {
  height:7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 3.68rem;
    height: 2.24rem;
  }
  p {
    font-size: 0.28rem;
    text-align: center;
    font-weight: 500;
    margin-top: 0.2rem;
  }
}
</style>